var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPublic5G(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56,18.75A13.26522,13.26522,0,0,1,69.25,32h1.5a14.75,14.75,0,0,0-29.5,0V52a14.75,14.75,0,0,0,29.5,0V41.25H54v1.5H69.25V52a13.25,13.25,0,0,1-26.5,0V32A13.26522,13.26522,0,0,1,56,18.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,66.75a14.75,14.75,0,0,0,0-29.5H12.75V20.75H36v-1.5H11.25v19.5H24A13.25,13.25,0,1,1,10.75,52H9.25A14.76686,14.76686,0,0,0,24,66.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublic5G);
export default __webpack_public_path__ + "static/media/icon_public_5g.f2e962270a860b6bcc4f8841a1e8e0d8.svg";
export { ForwardRef as ReactComponent };